export default function elementObserver({ context = document, sel }) {
  let interval;
  const TIMEOUT = 10000;

  const promise = new Promise((resolve) => {
    interval = setInterval(() => {
      const d = context.querySelector(sel);
      if (d) {
        resolve(d);
        clearInterval(interval);
      }
    }, 10);
  });

  function clearObserver() {
    clearInterval(interval);
  }

  setTimeout(() => clearObserver, TIMEOUT);

  return { clearObserver, promise };
}
